import React, { useState, useEffect } from 'react';
import { doc, updateDoc, arrayUnion, increment } from 'firebase/firestore';
import { db } from '../../firebase';
import './Event.css';

function SignUpPopup({ event, onClose, onConfirm }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [numPersons, setNumPersons] = useState(1);
  const [totalCost, setTotalCost] = useState(0);
  const [canConfirm, setCanConfirm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (event.costPerPerson && event.costPerPerson > 0) {
      setTotalCost(numPersons * event.costPerPerson);
    } else {
      setTotalCost(0);
    }
  }, [numPersons, event.costPerPerson]);

  useEffect(() => {
    const emailValid = email.trim() !== '' && /\S+@\S+\.\S+/.test(email);
    const nameValid = name.trim() !== '';
    const numValid = numPersons > 0;
    setCanConfirm(emailValid && nameValid && numValid);
  }, [name, email, numPersons]);

  const handleConfirm = async () => {
    if (!canConfirm || isSubmitting) return;
    setIsSubmitting(true);

    try {
      const eventRef = doc(db, 'events', event.id);
      await updateDoc(eventRef, {
        attendees: arrayUnion(name),
        numberOfSignedUp: increment(numPersons),
      });

      if (onConfirm) {
        onConfirm({ name, email, numPersons, totalCost });
      }

      setStatus('success');
    } catch (error) {
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={e => e.stopPropagation()}>
        {status === 'success' ? (
          <div className="signup-confirmation">
            <div className="signup-icon success">
              <svg width="60" height="60" viewBox="0 0 60 60">
                <circle cx="30" cy="30" r="28" fill="#07225e" />
                <polyline
                  points="18,32 27,41 43,22"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="signup-message">
              <h3>Sign-up Confirmed!</h3>
              <p>Your registration was successful.</p>
            </div>
            <button className="confirm-btn" onClick={onClose}>Close</button>
          </div>
        ) : status === 'error' ? (
          <div className="signup-confirmation">
            <div className="signup-icon error">
              <svg width="60" height="60" viewBox="0 0 60 60">
                <circle cx="30" cy="30" r="28" fill="#e53e3e" />
                <line x1="20" y1="20" x2="40" y2="40" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
                <line x1="40" y1="20" x2="20" y2="40" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
              </svg>
            </div>
            <div className="signup-message">
              <h3>Something went wrong</h3>
              <p>We couldn't process your sign-up. Please try again.</p>
            </div>
            <button className="cancel-btn" onClick={onClose}>Close</button>
          </div>
        ) : (
          <>
            <h2>Sign Up for {event.name}</h2>
            <form className="signup-form-flex" onSubmit={e => e.preventDefault()}>
              <div className="signup-fields-flex">
                <label>
                  Name:
                  <input
                    type="text"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    required
                  />
                </label>
                <label>
                  Email Address:
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                </label>
                <label>
                  Number of Persons:
                  <input
                    type="number"
                    min="1"
                    value={numPersons}
                    onChange={e => setNumPersons(Number(e.target.value) || 1)}
                    required
                  />
                </label>
                {event.costPerPerson > 0 && (
                  <p>
                    Price per person: €{event.costPerPerson}<br />
                    <strong>Total cost: €{totalCost}</strong>
                  </p>
                )}
              </div>
              <div className="signup-buttons-flex">
                <button
                  type="button"
                  disabled={!canConfirm || isSubmitting}
                  onClick={handleConfirm}
                  className="confirm-btn"
                >
                  {isSubmitting ? 'Signing Up...' : 'Confirm'}
                </button>
                <button type="button" onClick={onClose} className="cancel-btn" disabled={isSubmitting}>
                  Cancel
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default SignUpPopup;